export const dlSubscribeErrorEvent = (target, email) => {
    window.dataLayer.push({
        event: 'subscribe_error',
        contact: {
            target,
            email
        }
    });
};
